import { oneLine } from 'common-tags';

import { Text } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeNotFoundProps } from './types';

/**
 * FeaturedText
 */
export const NotFound: FunctionComponent<TypeNotFoundProps> = ({
  className = '',
  Icon,
  iconClassName = '',
  children,
  text,
  subtext,
  surfaceClass = 'bg-primary-50',
}: TypeNotFoundProps) => (
  <div
    className={oneLine`rounded-custom ${surfaceClass} flex max-w-md flex-col items-center gap-4 py-4 pr-4 pl-2 md:justify-center ${className} `}
  >
    <Icon
      width={64}
      height={64}
      className={oneLine`shrink-0 ${iconClassName}`}
    />

    <div className="flex flex-col justify-between gap-4 md:w-full md:items-center">
      <Text className="text-body text-body-m md:text-headline md:text-headline-h4 text-center font-bold">
        {text}
      </Text>
      <Text className="text-body-l mb-6 text-center">{subtext}</Text>

      {children}
    </div>
  </div>
);

NotFound.displayName = 'NotFound';
